module.exports = __webpack_public_path__ + "img/icon-component-label_Seckill.18228bd2.svg";